import { useState, useEffect } from "react";
import { supabase } from "@/lib/supabaseClient";

const FALLBACK = {
  company_name:  "Konyap Mühendislik",
  phone:         "+90 532 065 8519",
  email:         "konyapmuhendislik@gmail.com",
  address:       "Uluırmak Mah. Dr. Ahmet Özcan Cad. 179A Meram/KONYA",
  working_hours: "Pzt - Cmt: 09:00 - 18:00",
  instagram_url: "https://www.instagram.com/konyapmuhendislik/",
  facebook_url:  "",
  youtube_url:   "",
  linkedin_url:  "",
  logo_url:      "",
  favicon_url:   "",
};

// Module-level cache — one Supabase fetch per session regardless of how many
// components call useCompanySettings() (Header + Footer = 2 consumers).
let _cache   = null;  // settled result
let _promise = null;  // in-flight request

const fetchSettings = () => {
  if (!supabase) return Promise.resolve(null);
  if (_promise) return _promise;

  _promise = supabase
    .from("company_settings")
    .select("*")
    .eq("id", 1)
    .single()
    .then(({ data, error }) => {
      if (error || !data) return null;
      const result = {
        loaded:        true,
        company_name:  data.company_name  ?? "",
        phone:         data.phone         ?? "",
        email:         data.email         ?? "",
        address:       data.address       ?? "",
        working_hours: data.working_hours  ?? "",
        instagram_url: data.instagram_url  ?? "",
        facebook_url:  data.facebook_url   ?? "",
        youtube_url:   data.youtube_url    ?? "",
        linkedin_url:  data.linkedin_url   ?? "",
        logo_url:      data.logo_url       ?? "",
        favicon_url:   data.favicon_url    ?? "",
      };
      _cache = result;
      return result;
    })
    .catch(() => null);

  return _promise;
};

export function useCompanySettings() {
  const [company, setCompany] = useState(() =>
    _cache ?? { loaded: false, ...FALLBACK }
  );

  useEffect(() => {
    if (_cache) return; // already resolved — no re-fetch needed
    fetchSettings().then(result => {
      if (result) setCompany(result);
    });
  }, []);

  return company;
}
